import { render, staticRenderFns } from "./DuelChallenge_Section_Explanation.vue?vue&type=template&id=f501646c&scoped=true&"
import script from "./DuelChallenge_Section_Explanation.vue?vue&type=script&lang=js&"
export * from "./DuelChallenge_Section_Explanation.vue?vue&type=script&lang=js&"
import style0 from "./DuelChallenge_Section_Explanation.vue?vue&type=style&index=0&id=f501646c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f501646c",
  null
  
)

export default component.exports